import React from 'react';
import { CategoriesSection } from './CategoriesSection';
import { InProgressStudantSection } from './InProgressStudantSection';
import { LastPublishedStudentSection } from './LastPublishedStudentSection';
import { MostAccessedStudentSection } from './MostAccessedStudentSection';
import { OrganizationBanner } from './OrganizationBanner';
import './styles.scss';
import { TopRatedStudentSection } from './TopRatedStudentSection';

const HomeStudentWhiteLabel = () => {
    return (
        <div className="home-student-whitelabel-conteiner">
            <OrganizationBanner />

            <CategoriesSection />

            <div className="content-section-container">
                <InProgressStudantSection />

                <LastPublishedStudentSection />

                <MostAccessedStudentSection />

                <TopRatedStudentSection />
            </div>
        </div>
    );
};

export { HomeStudentWhiteLabel };
